import { __assign } from "tslib";
import { BreakpointNames, } from '../../../theme/Breakpoint/Breakpoint';
import { Spacing } from '../../../theme/Spacing/Spacing';
import { NegativeSizeType, SizeType, } from '../../../theme/Spacing/Spacing.types';
import { mq } from '../../../theme/MediaQuery/MediaQuery';
var SPACING_SHORTHAND_PROPS = [
    'm',
    'mh',
    'mv',
    'mt',
    'mb',
    'ml',
    'mr',
    'p',
    'ph',
    'pv',
    'pt',
    'pr',
    'pb',
    'pl',
];
var spacingShortHandToCssPropMap = {
    m: ['margin'],
    mh: ['marginLeft', 'marginRight'],
    mv: ['marginTop', 'marginBottom'],
    mt: ['marginTop'],
    mr: ['marginRight'],
    mb: ['marginBottom'],
    ml: ['marginLeft'],
    p: ['padding'],
    ph: ['paddingLeft', 'paddingRight'],
    pv: ['paddingTop', 'paddingBottom'],
    pt: ['paddingTop'],
    pr: ['paddingRight'],
    pb: ['paddingBottom'],
    pl: ['paddingLeft'],
};
function getCssPropsForSpacing(prop) {
    return spacingShortHandToCssPropMap[prop];
}
function constructCssForSpacing(spacingProp, spacingName) {
    return BreakpointNames.reduce(function (acc, breakpointName) {
        var _a;
        var negative = spacingName.charAt(0) === '-';
        var absSpacingName = (negative
            ? spacingName.substr(1)
            : spacingName);
        try {
            var spacingCss = getCssPropsForSpacing(spacingProp).reduce(function (_acc, spacingCssProp) {
                var _a;
                var spacingValue = Spacing[breakpointName][absSpacingName] * (negative ? -1 : 1);
                return __assign(__assign({}, _acc), (_a = {}, _a[spacingCssProp] = spacingValue + 'px', _a));
            }, {});
            return __assign(__assign({}, acc), (_a = {}, _a[mq.min(breakpointName)] = spacingCss, _a));
        }
        catch (e) {
            // eslint-disable-next-line no-console
            console.warn("Could not construct style rule for size [" + absSpacingName + "], breakpoint [" + breakpointName + "].", e);
            return acc;
        }
    }, {});
}
var _responsiveSpacing = Object.create(null);
SPACING_SHORTHAND_PROPS.forEach(function (spacingProp) {
    var spacing = (_responsiveSpacing[spacingProp] = Object.create(null));
    Object.values(__assign(__assign({}, SizeType), NegativeSizeType)).forEach(function (size) {
        Object.defineProperty(spacing, size, {
            get: function () {
                return constructCssForSpacing(spacingProp, size);
            },
        });
    });
});
/** responsiveSpacing{'p', 'ph', 'pt', ...}{'xs', 's', '-s', ...} gives
 * media queries with margin/paddings you asked for. */
export var responsiveSpacing = _responsiveSpacing;
/** @deprecated Use responsiveSpacing instead.
 * Just an alias now for `responsiveSpacing`. */
export var spacingMixin = responsiveSpacing;
//# sourceMappingURL=responsiveSpacing.js.map